import { userQueryKeys } from '@/api/user';

interface UserQueryClient {
  invalidateQueries: (filters: { queryKey: readonly unknown[] }) => Promise<unknown>;
}

export async function invalidateUserDetailAndLists(queryClient: UserQueryClient, userId: number): Promise<void> {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: userQueryKeys.detail(userId) }),
    queryClient.invalidateQueries({ queryKey: userQueryKeys.lists() }),
  ]);
}
